import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/layout/Layout.vue'
import Login from '@/views/layout/Login.vue'
import error404 from '@/views/error/404.vue'
import Home from '@/views/Home.vue'
import demo from '@/views/demo/Test.vue'

Vue.use(Router);
export const routes = [
  { name: 'login', path: '/', component: Login, meta: { hidden: true,title: "系统登录" } },
  {
    name: 'main', path: '/Index', component: Layout, meta: { hidden: true }, children: [
      { name: 'home', path: '/Home', component: Home, meta: { hidden: true, title: "Home", affix: true } },
    ]
  }
]
export default new Router({
  mode: 'hash',
  base: 'scm',
  routes
});



export const addRoleMenus = function () {
  const vue = window['Vue'] as Vue;
  if (vue && (vue.$store.state.app.loadMenus === false && vue.$auth.getToken())) {
    vue.$http.get('/Home/GetRouters').then(res => {
      const menus = buildMenus(res.data);

      vue.$store.dispatch('SetMenus', { menus });

      const routers = menuToRouters(menus, 0);

      // 这里放不需要在菜单中显示的路由
      routers.push({ name: '404', path: '/*', meta: { title: 'NotFound', icon: 'ww' }, component: error404 })
      vue.$router.addRoutes(routers);
    });
  }

  function buildMenus(data): any[] {
    const menus = new Array();
    for (let i = 0; i < data.length; i++) {
      try {
        const menu = { name: '', path: '', meta: { title: '', icon: '', single: false }, component: null, children: new Array() };
        menu.name = data[i].Name || vue.$utils.Guid()
        menu.path = data[i].Url;
        menu.component = require('@/views/' + (data[i].Path || 'layout/Layout') + '.vue').default
        menu.meta.title = data[i].Title
        menu.meta.icon = data[i].Icon
        menu.meta.single = data[i].IsSingle
        if (data[i].Children) {
          menu.children.push(...buildMenus(data[i].Children))
        }
        menus.push(menu)
      } catch (e) { 
        console.log();
      }
    }
    return menus;
  }

  function menuToRouters(data, deep) {
    const routers = new Array();
    for (let i = 0; i < data.length; i++) {
      if (data[i].children && data[i].children.length > 0) {
        if (deep === 0) {
          routers.push(Object.assign({}, { ...data[i], children: menuToRouters(data[i].children, deep + 1) }))
        }
        else {
          if (data[i].children && data[i].children.length > 0) {
            routers.push(...menuToRouters(data[i].children, deep + 1));
          } else {
            routers.push(data[i])
          }
        }
      }
      else {
        if (deep === 0) {
          if (data[i].meta.single === true) {
            routers.push(data[i])
          } else {
            const vue = window['Vue'] as Vue;
            routers.push({
              name: vue.$utils.Guid(), path: '/Index', component: Layout, meta: { hidden: true }, children: [data[i]]
            })
          }
        }
        else {
          routers.push(data[i])
        }
      }
    }
    return routers;
  }

}
